import Segment from '../shared/segment';
import Field from '../shared/field';

function Time() {
  const date = new Date();
  return (
    <Segment dir='auto'>
      <Field title='iso string' content={date.toISOString()} />
      <Field title='locale date' content={date.toLocaleDateString()} />
      <Field title='locale date fa' content={date.toLocaleDateString('fa')} />
      <Field title='locale time' content={date.toLocaleTimeString()} />
      <Field title='locale time fa' content={date.toLocaleTimeString('fa')} />
      <Field
        title='locale time fa tehran'
        content={date.toLocaleTimeString('fa', { timeZone: 'Asia/Tehran' })}
      />
      <Field ltr title='timezone' content={date.getTimezoneOffset() / 60} />
      <Field title='utc time' content={`${date.getUTCHours()}:${date.getUTCMinutes()}`} />
    </Segment>
  );
}

export default Time;
